import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBusinessDashboard } from "../store/slices/businessOwnerSlice";
import { showApiError } from "../utils/toast";

export const useBusinessDashboard = () => {
  const dispatch = useDispatch();
  const { dashboard, dashboardLoading, dashboardError } = useSelector(
    (state) => state.businessOwner
  );

  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);

  useEffect(() => {
    if (!hasFetched) {
      fetchDashboard();
    }
  }, [hasFetched]);

  const fetchDashboard = async () => {
    console.log("fetchDashboard called, current state:", { loading, dashboardLoading, hasFetched });
    
    // Check auth state
    const token = localStorage.getItem("authToken");
    const user = localStorage.getItem("authUser");
    console.log("Auth check:", { 
      hasToken: !!token, 
      tokenLength: token?.length,
      user: user ? JSON.parse(user) : null 
    });
    
    if (!token) {
      console.error("No auth token found!");
      showApiError(null, "Authentication required. Please login again.");
      return;
    }
    
    setLoading(true);
    setHasFetched(true);
    
    try {
      console.log("Dispatching getBusinessDashboard...");
      const result = await dispatch(getBusinessDashboard());
      console.log("Dashboard API result:", result);
    } catch (error) {
      console.error("Dashboard fetch error:", error);
      showApiError(null, "Failed to load dashboard data");
    } finally {
      setLoading(false);
    }
  };

  const refreshDashboard = () => {
    setHasFetched(false); // Reset to allow refetch
    fetchDashboard();
  };

  // Test function to check API directly
  const testApiDirectly = async () => {
    console.log("Testing API directly...");
    const token = localStorage.getItem("authToken");
    
    try {
      const response = await fetch("https://api.connectri.in/api/v1/dashboard/business-owner/reports/dashboard", {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
      
      console.log("Direct API response status:", response.status);
      console.log("Direct API response headers:", response.headers);
      
      if (response.ok) {
        const data = await response.json();
        console.log("Direct API response data:", data);
      } else {
        const errorText = await response.text();
        console.error("Direct API error:", errorText);
      }
    } catch (error) {
      console.error("Direct API fetch error:", error);
    }
  };

  return {
    dashboard,
    loading: loading || dashboardLoading,
    error: dashboardError,
    refreshDashboard,
    testApiDirectly // Expose for debugging
  };
};